import { IP_TO_USD_CONVERSION_RATE } from '../constants';

export const getInsaLoginRenderer = (
  {
    welcome_instapoint,
    initial_referral_instapoint,
    acknowledgement_instapoint,
    acknowledgement_instapoint_hours_limit,
    country_code
  },
  isReferred
) => {
  const total_instapoint = welcome_instapoint + acknowledgement_instapoint,
    isUSRemitter = country_code === 'US';
  const instapointValue = isReferred
    ? `${Math.floor((total_instapoint + initial_referral_instapoint) * IP_TO_USD_CONVERSION_RATE)}`
    : `${parseInt(total_instapoint * IP_TO_USD_CONVERSION_RATE)}`;
  return [
    {
      id: 'welcome_instapoint',
      totalValueShown: false,
      instaPointsValues: {
        information: 'Earned',
        value: isReferred ? welcome_instapoint + initial_referral_instapoint : welcome_instapoint,
        postfix: 'InstaPoints',
        isContentWithMarkup: false
      },
      instaPointsContent: {
        title: isReferred ? 'Sign up + referral' : 'Sign up',
        subTitile: isReferred
          ? '400 referral points added on 75 welcome credits'
          : 'Welcome credits',
        isContentWithMarkup: false
      },
      showDownArrowImage: true
    },
    {
      id: 'acknowledgement_instapoint',
      totalValueShown: false,
      instaPointsValues: {
        information: 'Get',
        value: acknowledgement_instapoint,
        postfix: 'InstaPoints',
        isContentWithMarkup: false
      },
      instaPointsContent: {
        title: 'Complete your profile',
        subTitile: `Within ${acknowledgement_instapoint_hours_limit} hours from signup*`,
        isContentWithMarkup: false
      },
      showDownArrowImage: true
    },
    {
      id: 'total_instapoint',
      totalValueShown: true,
      instaPointsValues: {
        information: 'Total',
        value: isReferred ? total_instapoint + initial_referral_instapoint : total_instapoint,
        postfix: 'InstaPoints',
        isContentWithMarkup: false
      },
      instaPointsContent: {
        title: isUSRemitter
          ? `<span class="eqauls-sign">=</span>
                <div class="row-continer">
                    <span class="bonus-value">$${instapointValue}</span>
                    <span class="bonus-text">Bonus</span>
                </div>`
          : 'More the Instapoints, more the benefits!',
        subTitile: isUSRemitter ? '<span>#DoMore</span>' : '#DoMore',
        isContentWithMarkup: isUSRemitter
      },
      showDownArrowImage: false
    }
  ];
};

export const getTimelineHeadingConfig = (
  instapointsLogicData = {},
  user_session,
  referred_by_referral_code
) => {
  const {
      welcome_instapoint,
      initial_referral_instapoint,
      acknowledgement_instapoint,
      acknowledgement_instapoint_hours_limit,
      acknowledgement_instapoint_expiry_days
    } = instapointsLogicData,
    { isReferralCodeSubmittedOnSignup, isReferralCodeSubmittedOnPersonalDetails } = user_session;
  let signUpHeading = [],
    personalDetailsHeading = [],
    acknowledgementHeading = '';
  const totalInstapoints = welcome_instapoint + acknowledgement_instapoint;

  const referralHeading = [
    {
      title: 'Sign Up Bonus',
      value: `${welcome_instapoint} IPs`,
      titleClassName: 'brand-blue-color',
      valueClassName: 'brand-blue-color',
      points: welcome_instapoint
    },
    {
      title: 'Referral Bonus',
      value: `+ ${initial_referral_instapoint} IPs`,
      titleClassName: 'brand-blue-color',
      valueClassName: 'brand-blue-color',
      points: initial_referral_instapoint
    },
    {
      title: 'You Earned',
      value: `${welcome_instapoint + initial_referral_instapoint} IPs`,
      titleClassName: 'brand-blue-color',
      valueClassName: 'brand-blue-color',
      parentClassName: 'dark-top-border',
      points: welcome_instapoint + initial_referral_instapoint
    },
    {
      title: `Complete your profile within ${acknowledgement_instapoint_hours_limit} hours`,
      value: `+ ${acknowledgement_instapoint} IPs`,
      titleClassName: 'gray-text-color',
      valueClassName: 'gray-text-color',
      parentClassName: 'multi-line-data',
      points: acknowledgement_instapoint
    },
    {
      title: 'Total',
      value: `${totalInstapoints + initial_referral_instapoint} IPs`,
      titleClassName: 'brand-blue-color',
      valueClassName: 'brand-blue-color',
      parentClassName: 'dark-top-border',
      points: acknowledgement_instapoint
    }
  ];

  const withoutReferralHeading = [
    {
      title: 'Sign Up Bonus',
      value: `${welcome_instapoint} IPs`,
      titleClassName: 'brand-blue-color',
      valueClassName: 'brand-blue-color',
      points: welcome_instapoint
    },
    {
      title: `Complete your profile within ${acknowledgement_instapoint_hours_limit} hours`,
      value: `+ ${acknowledgement_instapoint} IPs`,
      titleClassName: 'gray-text-color',
      valueClassName: 'gray-text-color',
      parentClassName: 'multi-line-data',
      points: acknowledgement_instapoint
    },
    {
      title: 'Total',
      value: `${totalInstapoints} IPs`,
      titleClassName: 'brand-blue-color',
      valueClassName: 'brand-blue-color',
      parentClassName: 'dark-top-border',
      points: totalInstapoints
    }
  ];
  if (isReferralCodeSubmittedOnSignup) {
    signUpHeading = referralHeading;
  } else if (isReferralCodeSubmittedOnPersonalDetails) {
    signUpHeading = withoutReferralHeading;
    personalDetailsHeading = referralHeading;
  } else if (referred_by_referral_code) {
    signUpHeading = referralHeading;
  } else {
    signUpHeading = withoutReferralHeading;
  }
  acknowledgementHeading = `<p class='brand-blue-color acknowledgement-info'><span class='normal-blue-color'>This is how:
   </span>Upload your documents or e-Verify yourself within ${acknowledgement_instapoint_hours_limit} hours of Signing Up.
    And we will credit <span class='normal-blue-color'>${acknowledgement_instapoint} InstaPoints Extra</span>
     <span class='gray-text-color validity'>(valid for ${acknowledgement_instapoint_expiry_days} days) </span>over and above your Sign Up ${
    referred_by_referral_code ? `and Referral` : ''
  } bonus of ${
    referred_by_referral_code
      ? initial_referral_instapoint + welcome_instapoint
      : welcome_instapoint
  } InstaPoints!</p>`;
  return {
    signUpHeading,
    acknowledgementHeading,
    personalDetailsHeading
  };
};
